export default "__VITE_ASSET__BIBbaYvs__"